import 'babel-polyfill';
import 'array-from-polyfill';
import 'element-closest';
import 'whatwg-fetch';
import "jquery"
import 'throttle-debounce';

import MainPage from '../partials/main-page';
import FlatsListPage from '../partials/flats-list-page';
import FlatsVisualPage from '../partials/flats-visual-page';
import FlatsItemPage from '../partials/flats-item-page';
import ErrorPage from '../partials/error-page';
import FlatsTypesPage from '../partials/flats-types-page';
import Analytics from '../partials/analytics';
import '../partials/animate-letter.js';
//new js
import '../partials/modal-data-rotation-mobile.js'

const find = require('array.prototype.find');
const wrapperId = document.querySelector(`.wrapper`) && document.querySelector(`.wrapper`).dataset.id;
const locale = document.querySelector(`body`).dataset.lang;

find.shim();

const pages = {
  [`main`]: MainPage,
  [`flats-list`]: FlatsListPage,
  [`flats-visual`]: FlatsVisualPage,
  [`flats-item`]: FlatsItemPage,
  [`error`]: ErrorPage,
  [`flats-types`]: FlatsTypesPage
};

export default class Application {
  static initPage(page) {
    const SelectedPage = pages[page];
    let currentPage = null;

    if (!SelectedPage) return;

    currentPage = new SelectedPage;

    document.addEventListener(`DOMContentLoaded`, () => {
      currentPage.init(locale);
    });
  }
}

Application.initPage(wrapperId);
Analytics.init();

$(function(){
  $(".flats-types__toggle").click(function(el){
    if (el.currentTarget.attributes.href.value.length && el.currentTarget.attributes.href.value.startsWith('#')) {
      window.location.hash = el.currentTarget.attributes.href.value;
    }
  });
});
